import * as React from 'react'
import { Text, TouchableOpacity, View, Platform } from 'react-native'
import styled from '@theme/styled-components'
import Theme from '@theme/Theme'

import Icon from '@components/icon/Icons'

import Screens from '@layout/Screens'

import useNavigation from '@layout/useNavigation'
import useI18n from '@i18n/useI18n'
import useTabs from '@utils/useTabs'

interface Props {
  current?: ScreenName
}

const Tabbar = ({ current }: Props) => {
  const i18n = useI18n()
  const navigation = useNavigation()
  const { drawer } = useTabs()
  const webCurrent = navigation.currentScreen()

  const renderItem = (item: ScreenName) => {
    const screen = Screens[item]
    const focused = (Platform.OS === 'web' ? webCurrent : current) === item

    return (
      <Item key={item} activeOpacity={0.9} onPress={() => navigation.jumpTo(`${item === 'home' ? '/' : screen.path}`)}>
        <Icon size={25} name={screen.icon} color={focused ? Theme.colors.primary : Theme.colors.primaryLight} />
        <Name focus={focused}>{i18n.t(`screens.${item}.title`)}</Name>
      </Item>
    )
  }

  return <Container>{drawer.map(renderItem)}</Container>
}

export default Tabbar

const Container = styled(View)`
  flex-direction: row;
  background-color: ${(props) => props.theme.colors.background};
  margin-bottom: ${(props) => props.theme.insets.bottom}px;
`

const Item = styled(TouchableOpacity)`
  flex: 1;
  padding: 10px 0;
  padding-bottom: 5px;
  align-items: center;
  justify-content: center;
`

const Name = styled(Text)<{ focus: boolean }>`
  ${(props) => props.theme.fonts.Caption2};
  color: ${(props) => (props.focus ? props.theme.colors.primary : props.theme.colors.secondaryText)};
  margin-top: 3px;
  text-align: center;
`
